const c = {
  name: "SmartRouting",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36,35c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S36,34.4,36,35z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3c0,1.7,1.3,3,3,3c1.3,0,2.4-0.8,2.8-2H35c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3H11
			c-2.8,0-5,2.2-5,5s2.2,5,5,5h12c1.7,0,3,1.3,3,3s-1.3,3-3,3H5c-2.8,0-5,2.2-5,5s2.2,5,5,5h25.1c0.5,2.3,2.5,4,4.9,4
			c2.8,0,5-2.2,5-5c0-2.8-2.2-5-5-5c-2.4,0-4.4,1.7-4.9,4H5c-1.7,0-3-1.3-3-3s1.3-3,3-3h18c2.8,0,5-2.2,5-5s-2.2-5-5-5H11
			c-1.7,0-3-1.3-3-3s1.3-3,3-3h24c2.8,0,5-2.2,5-5c0-2.8-2.2-5-5-5H5.8C5.4,0.8,4.3,0,3,0z M2,3c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1
			c0,0.6-0.4,1-1,1C2.4,4,2,3.6,2,3z M35,32c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3C32,33.3,33.3,32,35,32z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as SmartRouting
};
